import { useEffect, useState } from "react";
import { Timer } from "@phosphor-icons/react";
import { Pill } from "@/components/admin/AdminUI";

const fmt = (ms) => {
  const s = Math.floor(Math.abs(ms) / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h}h ${String(m).padStart(2, "0")}m ${String(s % 60).padStart(2, "0")}s`;
};

// Exact admin-facing countdown to a deadline (ticks every second).
export default function Countdown({ to, testId }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const left = new Date(to).getTime() - now;
  return (
    <Pill tone={left < 0 ? "error" : left < 3 * 3600 * 1000 ? "warning" : "neutral"} className="tabular-nums" data-testid={testId}>
      <Timer size={12} aria-hidden />{left < 0 ? `Overdue by ${fmt(left)}` : `Review in ${fmt(left)}`}
    </Pill>
  );
}
